"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var savedState;
var FilterService = (function () {
    function FilterService(templateMetadata, templateState, templates, updateTemplateState, simpleDropdownFactory, Search, getTemplateUseCase, initTemplateState, usingFeature, telemetry) {
        var _this = this;
        this.usingFeature = usingFeature;
        this.telemetry = telemetry;
        this.getDropdown = function () {
            var dropdownItems = getDropdownItems();
            var originalDropdownItem = dropdownItems.find(function (item) {
                return templateState.dropdownItem === item.id;
            });
            if (!originalDropdownItem && templateState.searchTerm == null) {
                templateState.dropdownItem = "all";
                originalDropdownItem = dropdownItems.find(function (item) {
                    return item.id === "all";
                });
                updateTemplateState(templateState, "invalid dropdown option");
            }
            return simpleDropdownFactory.create(dropdownItems, originalDropdownItem, selectDropdownItem);
        };
        var selectDropdownItem = function (dropdownItem) {
            templateState.dropdownItem = dropdownItem.id;
            if (templateState.dropdownItem === "my-templates") {
                templateState.projectId = undefined;
                templateState.useCase = undefined;
            }
            else {
                if (templateState.useCase == undefined) {
                    templateState.useCase = templateMetadata.useCases[0].toLowerCase();
                }
            }
            updateTemplateState(templateState, "dropdown clicked");
            _this.telemetry.track("Template Gallery Filter Changed", { template_gallery_filter: templateState.dropdownItem });
        };
        this.getSearch = function () {
            var search = new Search("Search all", function (query, action) {
                if (templateState.dropdownItem || templateState.useCase) {
                    savedState = lodash_1.default.cloneDeep(templateState);
                }
                if (action === "clear" || (action === "blur" && query.length === 0)) {
                    templateState = savedState || {};
                    initTemplateState(templateState);
                }
                else {
                    templateState.searchTerm = query;
                    templateState.dropdownItem = undefined;
                    templateState.useCase = undefined;
                    templateState.projectId = undefined;
                }
                updateTemplateState(templateState, "search ".concat(action, "d with ").concat(query));
            }, {
                theme: "expand-on-focus",
            });
            search.ui.input = templateState.searchTerm;
            return search;
        };
        this.getUseCases = function () {
            var isValidUseCase = false;
            var useCases = templateMetadata.useCases.map(function (useCase) {
                useCase = useCase.toLowerCase();
                if (useCase === templateState.useCase) {
                    isValidUseCase = true;
                }
                return getTemplateUseCase({
                    name: useCase,
                    active: useCase === templateState.useCase,
                    select: function (selectedUseCase) {
                        selectUseCase(selectedUseCase, useCases);
                    },
                });
            });
            if (!isValidUseCase && templateState.searchTerm == null && templateState.dropdownItem !== "my-templates") {
                templateState.useCase = templateMetadata.useCases[0].toLowerCase();
                useCases[0].active = true;
                updateTemplateState(templateState);
            }
            return useCases;
        };
        var selectUseCase = function (useCase, useCaseUis) {
            templateState.useCase = useCase;
            useCaseUis.forEach(function (useCaseUi) {
                useCaseUi.active = useCaseUi.name === useCase;
            });
            updateTemplateState(templateState, "use case clicked");
        };
        this.shouldShowDropdown = function () {
            return templateState.searchTerm == null;
        };
        this.shouldShowUseCases = function () {
            return (templateState.searchTerm == null &&
                templateState.dropdownItem !== "my-templates" &&
                templateState.dropdownItem !== "recommended");
        };
        var getDropdownItems = function () {
            var companyTypes = templateMetadata.companyTypes.filter(function (companyType) {
                return !!templates.library.find(function (template) {
                    return template.companyTypes && template.companyTypes.includes(companyType);
                });
            });
            var companyTypeDropdownItems = lodash_1.default.map(companyTypes, function (companyType) {
                return {
                    name: companyType,
                    id: lodash_1.default.kebabCase(companyType),
                };
            });
            return __spreadArray(__spreadArray([
                { name: "Recommended", id: "recommended" },
                { name: "My Templates", id: "my-templates" }
            ], __read(companyTypeDropdownItems), false), [
                { name: "All Templates", id: "all" },
            ], false);
        };
    }
    return FilterService;
}());
exports.default = FilterService;
